var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHwCorneringIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    className: "hw_icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Harsh Cornering") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.5,7.2l1.5.3a1.6,1.6,0,0,1,1.2,1.8v.5a.8.8,0,0,1-.9.7h-.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 22.4,
    cy: 13.1,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 10.1,
    cy: 10.7,
    r: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.3,7.4C9.7,6.7,9.9,6,9.9,6l.2-.8a3.8,3.8,0,0,1,4.6-3.1l6.7,1.3A4,4,0,0,1,24.5,8l-.2.9s-.1.7-3.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.9,6A2.8,2.8,0,0,0,7.7,7.3a4,4,0,0,0-.9,2l-.7,3.6a2.2,2.2,0,0,0,1.8,2.7l14.6,2.9a2.2,2.2,0,0,0,2.7-1.8l.7-3.6a4.1,4.1,0,0,0,0-2.2,2.7,2.7,0,0,0-1.6-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8,6.9H7.5a.8.8,0,0,1-.6-1V5.3A1.6,1.6,0,0,1,8.8,4.1l1.5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.2,12.3s0,1.4,2.8,2l13,2.5c2.8.5,3.4-.7,3.4-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.5,18.5l-.4,2.2a.6.6,0,0,1-.8.5L20.2,21c-.4-.1-.6-.4  -.5-.7l.4-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.9,15.6l-.4,2.3a.5.5,0,0,0,.5.7l1.1.3a.8.8,0,0,0,.8-.5l.4-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8,27c2.1.2,6,.2,5.6-.9S5.4,24,4.8,22.4,7,21.2,9,20.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20,29.9c2.2.2,6.1.2,5.6-.9s-8.2-2.1-8.8-3.7S19,24.1,21,23.7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHwCorneringIcon);
export default __webpack_public_path__ + "static/media/hw_cornering_icon.b16b88e1368571f4f9b96147ed818f5c.svg";
export { ForwardRef as ReactComponent };